import { useState } from 'react';

const useModalState = (open = false) => {
  const [isOpen, setIsOpen] = useState(open);

  const onOpen = () => {
    setIsOpen(true);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  const onToggle = () => {
    setIsOpen(!isOpen);
  };

  return { onOpen, onClose, isOpen, onToggle };
};

export default useModalState;
